import { Fragment } from 'react'

import { CustomLink } from '../../CustomLink'
import { ListItem } from '../ListItem'
import { TextListItemContent } from '../TextListItemContent'

import * as styles from './TextListItem.module.css'

function TextListItem(props) {
  const { className = styles.TextListItem, ...restProps } = props

  const Container = props.link ? CustomLink : Fragment
  const containerProps = props.link
    ? {
        className: styles.link,
        suffix: `${props.link.params}`,
        to: props.link.path,
      }
    : null

  return (
    <Container {...containerProps}>
      <ListItem
        {...restProps}
        Content={TextListItemContent}
        className={className}
      />
    </Container>
  )
}

export default TextListItem
